import { render, staticRenderFns } from "./ClientProviders.vue?vue&type=template&id=7c6a1ba2&"
import script from "./ClientProviders.vue?vue&type=script&lang=ts&"
export * from "./ClientProviders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports